import React, { useState,useEffect } from "react";
import { Link,useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SearchChildrens from "../components/popups/SearchChildrens";
import { GetChildrenInfoForList,ToggleDarkBackground,LoginAfterCheckLogin,isNull,GetChildrenStatusForList, isObjEmpty } from "../../components/common/Common";

import class01Icon from "../../img/icon/icon-center-class-01.svg";
import class03Icon from "../../img/icon/icon-center-class-03.svg";
import cancelIcon from "../../img/icon/icon-cancel.svg";


//원생추가
const StudyChildrenAdd = () => {
  let { cs_idx,stType } = useParams();  //수업차수고유번호, 수업종류
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //차수 배열
  const [varStudyList,setStudyList] = useState([]);
  const [varSelectStudyList,setSelectStudyList] = useState([]);

  //수업정보
  const [varStudyInfo,setStudyInfo] = useState({});

  //수업원생배열
  const [varAllStudyChildrenList,setAllStudyChildrenList] = useState([]);
  const [varStudyChildrenList,setStudyChildrenList] = useState([]);
  const [varAddStudyChildrenList,setAddStudyChildrenList] = useState([]);

  //검색
  const [varSearchString,setSearchString] = useState('');
  const [varChildrenList,setChildrenList] = useState([]);

  //수업/원생정보 호출
  const GetClassStudyInformation = async() => {
    const sendData = {cs_idx:cs_idx,mode:stType};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_study_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //클래스정보
        const studys = datas.studys[0];
        setStudyInfo(studys);

        //클래스에 등록된 원생 목록
        const allchildrens = datas.allchildrens;
        setAllStudyChildrenList(allchildrens);

        //수업에 참여된 원생정보
        const childrens = datas.childrens;
        let childrenList = [...childrens];
        if(Number(stType)>0) { //보강/참여수업의 경우
          childrenList = childrens.filter(el=>el.cs_idx===Number(cs_idx));
        }
        
        //수업에 참여중인 원생배열
        setStudyChildrenList(childrenList);

        //클래스 수업 차수 배열 호출
        GetAvaiableClassStudyList(studys.cs_cl_idx);
      }
    });
  }

  //유효수업차수 배열호출
  const GetAvaiableClassStudyList = async(cl_idx) => {
    const sendData = {cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_study_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const studyterms = datas.results;
        let sList = [];
        for(let i = 0; i < studyterms.length; i++) {
          let stData = studyterms[i];
          let indexes = {cs_index:stData.cs_index,cs_idx:stData.cs_idx};
          sList.push(indexes);
        }
        setStudyList(sList);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    //서버로부터 정보 호출
    GetClassStudyInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //수업차수변경시
  useEffect(() => {
    if(!isObjEmpty(varStudyInfo) && varStudyList.length>0) {
      if(varStudyInfo.st_num > 0 && varStudyInfo.ed_num > 0) {
        let csArray = [];
        for(let ii=varStudyInfo.st_num; ii <= varStudyInfo.ed_num; ii++) {
          let newData = varStudyList.find(element=>element.cs_index === ii);
          csArray.push(newData);
        }
        setSelectStudyList(csArray);
      }
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varStudyInfo,varStudyList]);

  //수업차수 설정
  const onChangePeriodHandler = (e,ino) => {
    const { name,value} = e.currentTarget;
    let nums = 0;
    if(name === "st_num") nums = varStudyInfo.ed_num - Number(value);
    else nums = Number(value) - varStudyInfo.st_num;
    if(nums > 1) {
      alert('보강수업은 2번을 초과할 수 없습니다.'); return false;
    }
    setStudyInfo({...varStudyInfo,[name]:Number(value)});
    setAddStudyChildrenList([]);
  }

  //검색문자변경
  const onChangeInputHandler = (e) => {
    const svalue = e.currentTarget.value;
    setSearchString(svalue);
  }

  //팝업창 - 원생검색
  const [varPopupSearchChildrens,setPopupSearchChildrens] = useState(false);
  const ToggleSearchChildrens = (bmode) => {
    ToggleDarkBackground(bmode);
    setPopupSearchChildrens(bmode);
  }

  //원생검색
  const onSearchingChildrenHandler = async(e) => {
    if(Number(stType) === 1) {
      if(varStudyInfo.st_num === 0) {
        alert('등록할 원생의 수업 시작차수를 먼저 선택하세요.'); return false;
      } else if(varStudyInfo.ed_num === 0) {
        alert('등록할 원생의 수업 끝차수를 먼저 선택하세요.'); return false;
      }
      if(varSelectStudyList.length === 0) {
        alert('등록할 원생의 수업차수배열이 완성되어 있지 않습니다. 시작과 끝차수를 먼저 선택해주세요.'); 
        return false;
      }
    }
    //if(varSearchString === "") {
      //alert('검색할 원생의 이름을 먼저 입력하세요.'); return false;
    //}
    const sendData = {branch_idx:branch_idx,sm_idx:varStudyInfo.sm_idx,cl_idx:varStudyInfo.cl_idx,searchString:varSearchString};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_search_childrens`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //클래스정보
        if(datas.results.length === 0){
          setChildrenList([]);
          alert('검색된 원생이 없습니다.');
        } else {
          const childrens = datas.results;

          //이미 지정된 원생은 제외
          let addChilds = [];
          childrens.forEach(children=>{     
            //등록가능수업수(smc_studys) 보다 등록한 수업수가 커서 추가로 등록할 수 없는 경우 제외 - 참여수업은 가능
            if(Number(stType) === 1 && isNull(children.smc_idx)){  //보강수업 && 결제가 아직 안된 경우
            } else {
              //원생이 전혀 등록되어 있지 않으면
              let findIndex1 = varStudyChildrenList.findIndex(el=>el.ch_idx === children.ch_idx);     //현제수업에 
              let findIndex2 = varAddStudyChildrenList.findIndex(el=>el.ch_idx === children.ch_idx);  //추가한 원생목록
              if(findIndex1 === -1 && findIndex2 === -1) {
                addChilds.push(children); //원생추가
              }
            }
          });

          console.log(addChilds);
          if(addChilds.length === 0) {
            setChildrenList([]);
            alert('추가할 원생이 없습니다.');
            ToggleSearchChildrens(false); //팝업창 닫기  
          } else {
            setChildrenList(addChilds);
            ToggleSearchChildrens(true);  //팝업창 열기
          }
        }
      } else {
        setChildrenList([]);
        alert(datas.message);
      }
    });
  }

  //원생추가
  const onSelectChildrenHandler = (e,childrenInfo) => {
    ToggleSearchChildrens(false);

    //이미 이 클래스에 등록된 원생인지 유뮤 확인
    let findIndex = varAllStudyChildrenList.findIndex(el=>el.ch_idx === childrenInfo.ch_idx);
    let addMode = 1;
    let clc_idx = 0;
    //이미 클래스에 원생이 존재하는 경우
    if(findIndex > -1) { 
      addMode = 0;
      clc_idx = varAllStudyChildrenList[findIndex].clc_idx;
    }

    let newList = [];
    let new_cs_idx1 = Number(cs_idx);
    let new_cs_idx2 = 0;
    if(Number(stType)===1) {
      new_cs_idx1 = varStudyList.find(el=>el.cs_index === varStudyInfo.st_num).cs_idx;
      //보강수업 점검
      if(varStudyInfo.st_num !==  varStudyInfo.ed_num) {
        //2번째수업추가
        new_cs_idx2 = varStudyList.find(el=>el.cs_index === varStudyInfo.ed_num).cs_idx;
      }
    }
    const newChildren = {cs_idx1:new_cs_idx1,cs_idx2:new_cs_idx2,clc_idx:clc_idx,clc_cs_index:varStudyInfo.st_num,
      ch_idx:childrenInfo.ch_idx,ch_name:childrenInfo.ch_name,ch_birthday:childrenInfo.ch_birthday,ch_gender:childrenInfo.ch_gender,
      smc_idx:childrenInfo.smc_idx,smc_store:childrenInfo.smc_store,smc_studys:childrenInfo.smc_studys,
      csc_idx:0,csc_cl_idx:varStudyInfo.cs_cl_idx,csc_mode:Number(stType),csc_cnt:0,csc_status:-1,addMode:addMode};
    console.log(newChildren);
    newList.push(newChildren);

    //원생배열에 추가
    setAddStudyChildrenList([...varAddStudyChildrenList,...newList]);
  }

  //추가된 원생 삭제
  const onDeleteAddedChildrenHandler = (e,ch_idx) => {
    console.log(ch_idx);
    const newList = varAddStudyChildrenList.filter(el=>el.ch_idx !== ch_idx);
    setAddStudyChildrenList(newList);
  }

  //원생등록
  const onRegisterChildrenHandler = async(e) => {
    if(varAddStudyChildrenList.length === 0) {
      alert('등록할 원생을 먼저 추가하세요.'); return false;
    }
    console.log(Number(stType),varStudyInfo);
    //보강수업일 경우
    if(Number(stType) === 1) {
      if(varStudyInfo.st_num === 0) {
        alert('등록할 원생의 수업 시작차수를 먼저 선택하세요.'); return false;
      } else if(varStudyInfo.ed_num === 0) {
        alert('등록할 원생의 수업 끝차수를 먼저 선택하세요.'); return false;
      }
      if(varSelectStudyList.length === 0) {
        alert('등록할 원생의 수업차수배열이 완성되어 있지 않습니다. 시작과 끝차수를 먼저 선택해주세요.'); 
        return false;
      }
    }

    const sendData = {csc_mode:Number(stType),dataInfo:varStudyInfo,dataList:varAddStudyChildrenList};
    console.log(sendData);

    if(!window.confirm('현재 조건으로 원생을 수업에 참여시키겠습니까?')) return false;

    await axios.post(`${process.env.REACT_APP_HOST}/branch_add_study_children`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        alert('원생을 추가하였습니다.');
        //보강의 경우 push 보내기
        if(Number(stType) === 1) SendPushMessage();
        else navigate(`/Branch/StudyChildrenSet/${varStudyInfo.cs_cl_idx}`);
      } else {
        alert(datas.message);
      }
    });
  }

  //푸시보내기
  const SendPushMessage = async () => {
    if(!window.confirm("푸시메시지를 발송하시겠습니까?")){
      navigate(`/Branch/StudyChildrenSet/${varStudyInfo.cs_cl_idx}`);
      return false;
    } 
    const pushTitle = "[마마몽떼] 보강수업배정.";
    const pushMessage = "보강수업이 배정되었습니다. 수업참여여부를 확인해주십시오.";
    const pushUrl = `${process.env.REACT_APP_WEB_URL}/Parents/ReinForce`;
    const sendData = {dataList:varAddStudyChildrenList,pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_push_reinforce_message`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        navigate(`/Branch/StudyChildrenSet/${varStudyInfo.cs_cl_idx}`);
      }
    });
  }

  return (
    <div className="vh-content kids-center-wrap">
      <HeaderBranchTitle varPageTitle={'원생 추가'} varBackString={`/Branch/StudyChildrenSet/${varStudyInfo.cs_cl_idx}`}/>
      <div className="vh-content-body">
        <div className="kids-search-form">
          <div className="center-wrap">
            <div className="class-info-box">
              <div className="txt-box">
                <p className="class-tit">선택 정보 확인</p>
                {Number(stType)>1?null
                :
                  <div className="cl-info-line flex">
                    <img src={class01Icon} alt=""/>
                    <p>선택한 차수</p>
                    <div>
                      <select name="st_num" value={varStudyInfo.st_num} onChange={e=>onChangePeriodHandler(e)}>
                        <option value={0}>시작차수</option>
                        {varStudyList.map((s_studys,i)=>(
                          <option key={'s_studys_'+i} value={s_studys.cs_index}>{s_studys.cs_index}차수업</option>
                        ))}
                      </select> ~
                      <select name="ed_num" value={varStudyInfo.ed_num} onChange={e=>onChangePeriodHandler(e)}>
                        <option value={0}>끝차수</option>
                        {varStudyList.map((e_studys,j)=>(
                          <option key={'e_studys_'+j} value={e_studys.cs_index}>{e_studys.cs_index}차수업</option>
                        ))}
                      </select>
                    </div>
                  </div>
                }
                <div className="cl-info-line flex">
                  <img src={class03Icon} alt=""/>
                  <p>선택한 수업</p>
                  <div>{Number(stType)===0?"정규":Number(stType)===1?"보강":"참여"}수업</div>
                </div>								
              </div>
            </div>
            <div className="search-wrap">
							<input type="text" name="searchString" className="search-input" placeholder="원아명을 검색하세요." value={varSearchString} onChange={e=>onChangeInputHandler(e)}/>
							<button onClick={e=>onSearchingChildrenHandler(e)}>검색</button>
						</div>
            <div className="search-ok-con">
							<div className="con">
                {varStudyChildrenList.map((childrens,i)=>(
                  <div key={'childrens_'+i}>
                    <p>{GetChildrenInfoForList(childrens,0)} {GetChildrenStatusForList(childrens,0)}</p>
                  </div>
                ))}    
                {varAddStudyChildrenList.map((childrens,i)=>(
                  <div key={'childrens_'+i}>
                    <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                      <span>{GetChildrenInfoForList(childrens,-1)} {GetChildrenStatusForList(childrens,1)}</span>
                      <img src={cancelIcon} style={{height:"21px"}} alt="" onClick={e=>onDeleteAddedChildrenHandler(e,childrens.ch_idx)}/>
                    </p>
                  </div>
                ))}        
							</div>
						</div>
            <div className="form-contoller bt-btn">
							<Link to={`/Branch/StudyChildrenSet/${varStudyInfo.cs_cl_idx}`} className="form-contoller-btn btn-no" style={{width:"48%"}}>취소</Link>
							<button className="form-contoller-btn btn-yes" onClick={e=>onRegisterChildrenHandler(e)}>등록</button>
						</div>
          </div>
        </div>
      </div>
      <SearchChildrens varPopupSearchChildrens={varPopupSearchChildrens} varChildrenList={varChildrenList} 
                    onSelectChildrenHandler={onSelectChildrenHandler} ToggleSearchChildrens={ToggleSearchChildrens}/>
    </div>
  )
}
export default StudyChildrenAdd;